import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: '[featurePermissionNone]'
})
export class FeaturePermissionNoneDirective {

  private _disabled = true;

  constructor() { }

  @HostBinding('attr.disabled') get isDisabled() { return this._disabled ? '' : null; }

  set disabled(val: boolean) {
    this._disabled = val;
  }
}
